import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {CategoryModel} from './Category.model';

@injectable()
export class CategoryFactory
  implements BaseDomainFactory<CategoryModel, CategoryModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CategoryModel.Props): CategoryModel {
    return this.modelsRegistry.put(new CategoryModel(props));
  }
}
